import type { DocumentDirectoryType, ObjectDocumentAiDocumentType } from '@econtractor/types';
import type { UploadDocumentFormValues } from '../UploadDocumentForm';

const DOCUMENT_TYPES = new Set<DocumentDirectoryType>(['invoice', 'contract', 'act', 'other']);

export const hasDocumentAiValues = (document: Partial<ObjectDocumentAiDocumentType>): boolean =>
    Boolean(
        String(document.proposalName || '').trim() ||
            String(document.proposalNumber || '').trim() ||
            String(document.proposalAmount || '').trim() ||
            String(document.generationComment || '').trim() ||
            (document.proposalDt && document.proposalDt > 0) ||
            String(document.proposalType || '').trim(),
    );

export const mergeDocumentFromAi = (
    current: UploadDocumentFormValues,
    parsed: Partial<ObjectDocumentAiDocumentType>,
    options?: { allowMarkPaid?: boolean },
): UploadDocumentFormValues => {
    const next: UploadDocumentFormValues = { ...current };
    const allowMarkPaid = Boolean(options?.allowMarkPaid);

    const proposalType = String(parsed.proposalType || '').trim() as DocumentDirectoryType;
    if (DOCUMENT_TYPES.has(proposalType)) {
        next.proposalType = proposalType;
    }

    if (String(parsed.proposalName || '').trim()) {
        next.proposalName = String(parsed.proposalName).trim();
    }

    if (String(parsed.proposalNumber || '').trim()) {
        next.proposalNumber = String(parsed.proposalNumber).trim().slice(0, 250);
    }

    if (parsed.proposalDt && Number(parsed.proposalDt) > 0) {
        next.proposalDt = Number(parsed.proposalDt);
    }

    if (String(parsed.proposalAmount || '').trim()) {
        next.proposalAmount = String(parsed.proposalAmount).trim();
    }

    if (String(parsed.generationComment || '').trim()) {
        next.generationComment = String(parsed.generationComment).trim().slice(0, 500);
    }

    if (typeof parsed.pricesInUsd === 'boolean') {
        next.pricesInUsd = parsed.pricesInUsd;
    }

    if (typeof parsed.proposalVat === 'boolean') {
        next.proposalVat = parsed.proposalVat;
    }

    if (allowMarkPaid && typeof parsed.markPaid === 'boolean') {
        next.markPaid = parsed.markPaid;
    }

    return next;
};
